var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.59998 3.60001C6.12541 3.60001 4.09998 5.62544 4.09998 8.10001V36.9C4.09998 39.3746 6.12541 41.4 8.59998 41.4H23.7488C23.846 41.4161 23.9452 41.4161 24.0424 41.4H29.1488C29.246 41.4161 29.3452 41.4161 29.4424 41.4H37.4C39.8745 41.4 41.9 39.3746 41.9 36.9V8.10001C41.9 5.62544 39.8745 3.60001 37.4 3.60001H8.59998ZM8.59998 5.40001H37.4C38.9016 5.40001 40.1 6.59837 40.1 8.10001V36.9C40.1 38.4016 38.9016 39.6 37.4 39.6H30.2V27H33.6383L34.8986 20.7H30.2V18.9C30.2 18.3983 30.2477 18.359 30.4162 18.2496C30.5847 18.1402 31.1052 18 32 18H34.7V12.9322L34.1867 12.6879C34.1867 12.6879 32.1194 11.7 29.3 11.7C27.275 11.7 25.6114 12.5068 24.5469 13.8375C23.4823 15.1682 23 16.95 23 18.9V20.7H20.3V27H23V39.6H8.59998C7.09834 39.6 5.89998 38.4016 5.89998 36.9V8.10001C5.89998 6.59837 7.09834 5.40001 8.59998 5.40001ZM29.3 13.5C31.1711 13.5 32.3486 13.9126 32.9 14.1311V16.2H32C30.9642 16.2 30.1342 16.2857 29.4353 16.7397C28.7364 17.1936 28.4 18.0553 28.4 18.9V22.5H32.7013L32.1617 25.2H28.4V39.6H24.8V25.2H22.1V22.5H24.8V18.9C24.8 17.25 25.2177 15.8818 25.9531 14.9625C26.6885 14.0432 27.725 13.5 29.3 13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d432697167f8871beee414b023e9b3c0.svg";
export { ForwardRef as ReactComponent };